import React, { useState } from 'react';

import { useConfig } from 'Context/ConfigContext';

import {
  FILTER_LIST_DEFAULT,
  FILTER_LIST_WITHOUT_PROGRESS,
  FILTER_LIST_WITHOUT_COURSE_FILTER,
  COURSE_FILTER,
  SORT_FILTER,
} from './constants';

const getOptions = (courseFilter) => {
  switch (courseFilter) {
    case 'withoutCourseFilter': {
      return FILTER_LIST_WITHOUT_COURSE_FILTER;
    }
    case 'withoutProgress': {
      return FILTER_LIST_WITHOUT_PROGRESS;
    }
    case 'default':
    default: {
      return FILTER_LIST_DEFAULT;
    }
  }
};

const useCourseFilter = () => {
  const { myCourses } = useConfig();
  const courseFilter = myCourses?.courseFilter;

  const [filter, setFilter] = useState({
    courses: COURSE_FILTER.CURRENT_COURSES,
    sort: SORT_FILTER.LATEST,
  });

  const onFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  return { filter, options: getOptions(courseFilter), onFilterChange, COURSE_FILTER, SORT_FILTER };
};

export default useCourseFilter;
